export const glossary = [
  {
    id: 1,
    term: 'Live-дилер',
    definition: 'Настоящий крупье, который ведет игру в режиме реального времени через видеотрансляцию. Вы видите все действия дилера и можете общаться с ним через чат.'
  },
  {
    id: 2,
    term: 'RTP (Return to Player)',
    definition: 'Процент возврата игроку - теоретический показатель того, какая часть ставок возвращается игрокам в долгосрочной перспективе. Например, RTP 97% означает, что из 100₽ ставок в среднем возвращается 97₽.'
  },
  {
    id: 3,
    term: 'Вейджер (Wager)',
    definition: 'Требование по отыгрышу бонуса. Показывает, сколько раз нужно прокрутить сумму бонуса перед выводом. Например, вейджер x30 на бонус 1000₽ означает необходимость сделать ставок на 30000₽.'
  },
  {
    id: 4,
    term: 'Evolution Gaming',
    definition: 'Крупнейший мировой провайдер live-игр, основанный в 2006 году. Предлагает более 500 игр с живыми дилерами, включая Lightning Roulette, Crazy Time и Monopoly Live.'
  },
  {
    id: 5,
    term: 'Immersive Roulette',
    definition: 'Инновационная рулетка от Evolution Gaming с несколькими камерами и замедленными повторами. Создает эффект полного погружения в игру.'
  },
  {
    id: 6,
    term: 'VIP стол',
    definition: 'Игровой стол с повышенными лимитами ставок для хайроллеров. Обычно предлагает эксклюзивное обслуживание и приватную атмосферу.'
  },
  {
    id: 7,
    term: 'Кэшбэк',
    definition: 'Возврат части проигранных средств. Обычно составляет 5-15% от суммы проигрыша за определенный период (неделя, месяц).'
  },
  {
    id: 8,
    term: 'Crazy Time',
    definition: 'Популярное игровое шоу от Evolution Gaming с колесом фортуны и четырьмя бонусными раундами. Максимальный множитель может достигать x20000.'
  },
  {
    id: 9,
    term: 'Squeeze (Сквиз)',
    definition: 'Медленное открытие карт в баккара, создающее дополнительное напряжение. Дилер постепенно приоткрывает край карты, позволяя игрокам угадывать её значение.'
  },
  {
    id: 10,
    term: 'Мультиплеер',
    definition: 'Режим игры, где за одним столом одновременно играют несколько игроков. Вы видите ставки других участников и можете общаться в чате.'
  },
  {
    id: 11,
    term: 'Lightning игры',
    definition: 'Серия игр от Evolution Gaming с случайными множителями. В каждом раунде выбираются счастливые номера/карты с множителями до x500.'
  },
  {
    id: 12,
    term: 'Pragmatic Play Live',
    definition: 'Провайдер live-игр, известный инновационными игровыми шоу, такими как Sweet Bonanza Candyland и Mega Wheel.'
  }
];